import { render } from "./SimpleSettingsForm.vue?vue&type=template&id=97d278f0"
import script from "./SimpleSettingsForm.vue?vue&type=script&lang=js"
export * from "./SimpleSettingsForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__